import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import baseUrl from "./BaseUrl";
import Loader from "./Loader";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [showTwoFA, setShowTwoFA] = useState(false);
  const [userId, setUserId] = useState(null);
  const [twoFACode, setTwoFACode] = useState("");
  // True until the existing-session check finishes, so a signed-in admin opening a
  // new tab goes straight to the dashboard instead of flashing the login form.
  const [checkingSession, setCheckingSession] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
        refreshToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

const refreshToken = async () => {
    try {
        const response = await axios.get(`${baseUrl}/admin/api/token`);
        if(response.data && response.data.accessToken){
            navigate("/dashboard", { replace: true });
            return;
        }
    } catch (error) {
        // No valid session — fall through and show the login form.
    }
    setCheckingSession(false);
}

const Authenticate = async (e) => {
    e.preventDefault();
    try {
        setPopupOpen(true);
        const response = await axios.post(`${baseUrl}/admin/api/login`, {
            email: email,
            password: password
        });
        setPopupOpen(false);
        
        // Check if 2FA is required
        if (response.data.requiresTwoFA) {
            setShowTwoFA(true);
            setUserId(response.data.userId);
            setIsSuccess(true);
            setMsg('Verification code sent to your email. Please check your inbox.');
        } else {
            // Old flow - direct login (shouldn't happen with new API)
            setIsSuccess(true);
            setMsg('Login successful');
            navigate("/dashboard");
        }
    } catch (error) {
        setPopupOpen(false);
        if (error.response) {
            setIsSuccess(false);
            setMsg(error.response.data.msg);
        }
    }
}

const verifyTwoFACode = async (e) => {
    e.preventDefault();
    try {
        setPopupOpen(true);
        const response = await axios.post(`${baseUrl}/admin/api/verify-2fa`, {
            userId: userId,
            code: twoFACode
        });
        setPopupOpen(false);
        
        if (response.data.success) {
            setIsSuccess(true);
            setMsg('Login successful');
            navigate("/dashboard");
        }
    } catch (error) {
        setPopupOpen(false);
        if (error.response) {
            setIsSuccess(false);
            setMsg(error.response.data.msg);
        }
    }
}

const resendCode = async () => {
    try {
        setPopupOpen(true);
        const response = await axios.post(`${baseUrl}/admin/api/login`, {
            email: email,
            password: password
        });
        setPopupOpen(false);
        
        if (response.data.requiresTwoFA) {
            setTwoFACode("");
            setIsSuccess(true);
            setMsg('New verification code sent to your email.');
        }
    } catch (error) {
        setPopupOpen(false);
        if (error.response) {
            setIsSuccess(false);
            setMsg(error.response.data.msg);
        }
    }
}

  if (checkingSession) {
    return <Loader />;
  }

  return (
        
    <section className="">
        {popupOpen && (
                <Loader /> 
        ) }
        <div className="row d-flex align-items-center">
                <div className="col-md-12 right-box">
                    <div className="form-body">
                        <div className="left-logo">
                            {/* <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="" /> */}
                        </div>
                        
                        {!showTwoFA ? (
                            // Login Form
                            <form onSubmit={Authenticate} className="form-box login-logo">
                                <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>
                                <div className="field mt-5">
                                    {/* <label className="label">Email or Username</label> */}
                                    <div className="controls">
                                    <input type="email" className="input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                    </div>
                                </div>
                                <div className="field mt-5">
                                    {/* <label className="label">Password</label> */}
                                    <div className="controls">
                                    <input type="password" className="input" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                    </div>
                                </div>
                                {/* <div class="col-12">
                                    <div class="forgot-pass-link"><Link to="/forgot-password">Forgot Password?</Link></div>
                                </div> */}
                                <div className="field mt-5 logindiv">
                                    {/* <button className="button is-success is-fullwidth">Login</button> */}
                                    <input type="submit" value="Sign In"></input>
                                </div>
                            </form>
                        ) : (
                            // 2FA Verification Form
                            <form onSubmit={verifyTwoFACode} className="form-box login-logo">
                                <div className="text-center mb-4">
                                    <h3 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '10px'}}>🔐 Two-Factor Authentication</h3>
                                    <p style={{color: '#666', fontSize: '14px'}}>We've sent a 6-digit code to your email</p>
                                </div>
                                
                                <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>
                                
                                <div className="field mt-5">
                                    <div className="controls">
                                        <input 
                                            type="text" 
                                            className="input" 
                                            placeholder="Enter 6-digit code" 
                                            value={twoFACode} 
                                            onChange={(e) => setTwoFACode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                            maxLength="6"
                                            style={{
                                                textAlign: 'center',
                                                fontSize: '24px',
                                                letterSpacing: '8px',
                                                fontWeight: 'bold'
                                            }}
                                            required 
                                            autoFocus
                                        />
                                    </div>
                                    <small style={{color: '#666', fontSize: '12px', display: 'block', marginTop: '8px', textAlign: 'center'}}>
                                        Code expires in 10 minutes
                                    </small>
                                </div>
                                
                                <div className="field mt-5 logindiv">
                                    <input type="submit" value="Verify Code"></input>
                                </div>
                                
                                <div className="field mt-3" style={{textAlign: 'center'}}>
                                    <button 
                                        type="button" 
                                        onClick={resendCode}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#fe825b',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        Resend Code
                                    </button>
                                    <span style={{margin: '0 10px', color: '#ccc'}}>|</span>
                                    <button 
                                        type="button" 
                                        onClick={() => {
                                            setShowTwoFA(false);
                                            setTwoFACode("");
                                            setMsg("");
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#666',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        Back to Login
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            
        </div>
    </section>
)
};

export default Login;
